import { render, staticRenderFns } from "./KIE.vue?vue&type=template&id=c0586d52&"
import script from "./KIE.vue?vue&type=script&lang=js&"
export * from "./KIE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports